import React from 'react';
import { Box, Skeleton, Text, Title } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { useIsMobile } from 'commons/hooks';

function EmptyStateThirdSectionSkeleton(): JSX.Element {
  const isMobile = useIsMobile();

  const SectionRowSkeleton = ({
    topDivider = true,
  }: {
    topDivider?: boolean;
  }) => (
    <DataList.Row
      topDivider={topDivider}
      backgroundColor={isMobile ? 'transparent' : 'neutral-surface'}
      paddingLeft="none"
    >
      <Box display="flex" flexDirection="column" gap="4">
        <Title.Skeleton width="100%" />
        <Text.Skeleton width="100%" />
      </Box>
    </DataList.Row>
  );

  return (
    <Box display="flex" flexDirection="column" gap="10">
      <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap="4">
        <Box flex="2" display="flex" flexDirection="column" gap="8">
          <Title.Skeleton as={isMobile ? 'h3' : 'h2'} width="100%" />
          {isMobile ? (
            <Box flex="1" display="flex" justifyContent="center">
              <Skeleton width="300px" height="300px" />
            </Box>
          ) : null}
          <DataList bottomDivider={false}>
            <SectionRowSkeleton topDivider={false} />
            <SectionRowSkeleton />
            <SectionRowSkeleton />
          </DataList>
        </Box>
        {isMobile ? null : (
          <Box flex="1" display="flex" justifyContent="flex-end">
            <Skeleton width="320px" height="320px" />
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default EmptyStateThirdSectionSkeleton;
